import { TextKey } from '@mews-commander/enums';
import { lt } from '@mews/framework';
import { WithGuideLink } from '@mews-commander/types';
import { FilterSidebarLayoutBase, FilterSidebarLayoutContent } from '../../../components/layout';
import { AvailabilityBlockReportFilterFields } from '../components/AvailabilityBlockReportFilterFields';
import { availabilityBlockReportFiltersSchema } from '../types';
import { useReservableServices } from '../queries/useReservableServices';
import { useDefaultFilterValues } from '../utils';
import { AvailabilityBlockReportTable } from '../components/AvailabilityBlockReportTable';
import { useHeadingActions } from '../hooks/useHeadingAction';
import { AvailabilityBlockReportExportsButton } from '../components/AvailabilityBlockReportExportsButton';
import { AvailabilityBlockReportContextProvider, useReportTableStateValue } from '../tableStateContext';

interface Props extends WithGuideLink {
    serviceId: string | null;
}

export const AvailabilityBlockReport: React.FC<Props> = ({ guideLink, serviceId }) => {
    const { data: reservableServices, isLoading: servicesLoading } = useReservableServices();

    const defaultValues = useDefaultFilterValues({ serviceId });
    const actions = useHeadingActions(reservableServices);

    const tableStateValue = useReportTableStateValue();

    return (
        <AvailabilityBlockReportContextProvider value={tableStateValue}>
            <FilterSidebarLayoutBase
                actions={actions}
                loading={servicesLoading}
                title={lt(TextKey.AvailabilityBlockReport)}
                guideLink={guideLink}
            >
                {(sidebarToggleProps) => (
                    <FilterSidebarLayoutContent
                        {...sidebarToggleProps}
                        filterSchema={availabilityBlockReportFiltersSchema}
                        defaultFilterValues={defaultValues}
                        filterSidebar={{
                            title: lt(TextKey.Filter),
                            fields: <AvailabilityBlockReportFilterFields services={reservableServices || []} />,
                            actions: AvailabilityBlockReportExportsButton,
                        }}
                    >
                        {({ filterValues }) => (
                            <AvailabilityBlockReportTable filters={filterValues} services={reservableServices} />
                        )}
                    </FilterSidebarLayoutContent>
                )}
            </FilterSidebarLayoutBase>
        </AvailabilityBlockReportContextProvider>
    );
};
